import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { ApplicationConfigService } from './application-config.service';
import { CurrentDataService } from './current-data-service';
import { BaryModalService } from './bary-modal.service';

@Injectable({ providedIn: 'root' })
export class BillService {
  protected endPointDownload = API_ENDPOINTS.DOWNLOAD_BILLS_PDF;
  protected endPointBrowserPdf = API_ENDPOINTS.BROWSER_BILLS_PDF;
  protected endPointExtract = API_ENDPOINTS.EXTRACT_BILLS_DATA;

  constructor(
    protected apiProvider: ApiProviderService,
    protected http: HttpClient,
    protected applicationConfigService: ApplicationConfigService,
    protected currentDataService: CurrentDataService,
    protected modalService: BaryModalService
  ) {}

  download(basketOrderId: number): void {
    this.apiProvider.download<any>(this.endPointDownload(basketOrderId));
  }

  browserPdf(basketOrderId: number): void {
    this.apiProvider.browserPdf<any>(this.endPointBrowserPdf(basketOrderId)).subscribe(objectPdf => {
      this.modalService.openBrowserPDF(objectPdf.blob, objectPdf.filename ?? 'facture.pdf', objectPdf.title);
    });
  }

  extractData(startDate: string, endDate: string, type: string, format: string): void {
    return this.apiProvider.download<any>(this.endPointExtract(startDate, endDate, type, format));
  }
}
